import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import {
  IUploadDocumentRequest,
  IUploadDocumentResponse,
} from '@/types/documents';

class DocumentsApi extends AbortControllerManager {
  private readonly DOCUMENTS_URL = '/v2/documents';

  constructor() {
    super();
  }

  uploadDocument({
    file,
    userInstitutionRoleId,
  }: IUploadDocumentRequest): Promise<IUploadDocumentResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('user_institution_role_id', userInstitutionRoleId);
    const signal = this.createAbortController(
      `upload-document-${file.name}-${file.size}-${file.type}`,
    );
    return authClient.post(this.DOCUMENTS_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      signal,
    });
  }
}

export const documentsApi = new DocumentsApi();
